import { SAVE_CLIENT, GET_CLIENTS, GET_CLIENTS_LOADING } from '../actions/Types'

const initialState = {
  data: [],
  loading: false,
}

export default function ClientReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_CLIENT:
      return {
        ...state,
        data: [...state.data, ...action.payload],
        signing: [...state.signing, ...action.payload],
      }
    case GET_CLIENTS:
      return {
        ...state,
        data: action.payload,
      }
    case GET_CLIENTS_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    default:
      return state
  }
}
